import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import { Helpers } from "../../../../helpers/Helpers";
import { GetAmbarListResponseAmbarExpectedIncomeOutcome } from "../../../../models/response/ambar/GetAmbarListResponse";

interface Props {
    data: GetAmbarListResponseAmbarExpectedIncomeOutcome[]
    setData: React.Dispatch<React.SetStateAction<GetAmbarListResponseAmbarExpectedIncomeOutcome[]>>
}

const Prices = ({
    data,
    setData
}: Props) => {
    const selectAll = () => {
        var isAllSelected = data.length == data.filter(x => x.isSelected).length;

        setData(data.map(function (x) {
            x.isSelected = !isAllSelected;

            return x;
        }));
    }

    const setItemSelected = (_id: string) => {
        setData(data.map(function (x) {
            if (x.uniqueId == _id)
                x.isSelected = !x.isSelected;

            return x;
        }));
    }

    return (
        <KTCard className="ebbe-card mt-10">
            <KTCardBody>
                <h4 className="mb-10 text-black">Bulunan Fiyatlar</h4>

                <div className="row mt-5">
                    <div className="col-md-12">
                        <div className='table-responsive'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.filter(x => x.isSelected).length > 0 && data.filter(x => x.isSelected).length == data.length} />
                                                </label>
                                            </div>
                                        </th>
                                        <th>Ref No</th>
                                        <th>Anlaşma Şablonu Adı</th>
                                        <th>Fiyat</th>
                                        <th>Brüt Fiyat</th>
                                    </tr>
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.map((item, index) =>
                                            <tr>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                            <input onChange={() => setItemSelected(item.uniqueId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>{item.refNo}</td>
                                                <td>{item.agreementSchemeName}</td>
                                                <td className="custom-text-right">{Helpers.correctPrice(item.totalWithoutTaxPrice)}</td>
                                                <td className="custom-text-right">{Helpers.correctPrice(item.totalPrice)}</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </KTCardBody>
        </KTCard>
    )
}

export default Prices;